import React, { useEffect, useState } from 'react'

import * as Styled from './styled'
import UserDropdown from './UserDropdown'
import ProjectName from './ProjectName'
import ExportButton from './ExportButton'
import { UndoRedo } from './UndoRedo'
import RefillButton from './RefillButton'
import AspectRatioSelect from './AspectRatioSelect'
import { useResponsive } from 'hooks/useResponsive'
import {
  NARROW_SCREEN_SIZE_BREAKPOINT,
  SMALL_DESKTOP_SIZE_BREAKPOINT
} from 'consts'
import { projectSelectors } from 'store/features/project/selectors'
import { useSelector } from 'react-redux'
import { UpgradeToExportButton } from './UpgradeToExportButton'
import { isAllowedDurationSelector } from 'store/selectors'
import { userSelectors } from 'store/features/user/selectors'
import ExportButtonDisabled from './ExportButtonSkeleton'

const Header: React.FC = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const isSmallScreen = useResponsive(NARROW_SCREEN_SIZE_BREAKPOINT)
  const projectId = useSelector(projectSelectors.id)
  const [showRegularExportButton, setShowRegularExportButton] = useState<
    boolean | null
  >(null)
  const activeHighestSubscriptionIsLoading = useSelector(
    userSelectors.activeHighestSubscriptionIsLoading
  )
  const isAllowedDuration = useSelector(isAllowedDurationSelector)
  const isProjectNameVisible = projectId && !isSmallScreen
  useEffect(() => {
    setShowRegularExportButton(isAllowedDuration)
  }, [activeHighestSubscriptionIsLoading, isAllowedDuration])

  return (
    <Styled.Header>
      <Styled.LeftBlock>
        <UndoRedo />
        <Styled.Separator $hideOnMobile />
        {!isMobile && <AspectRatioSelect />}
      </Styled.LeftBlock>
      {isProjectNameVisible && (
        <Styled.MiddleBlock>
          <ProjectName />
        </Styled.MiddleBlock>
      )}
      <Styled.RightBlock>
        <RefillButton />
        <Styled.Separator />
        {!activeHighestSubscriptionIsLoading ? (
          showRegularExportButton ? (
            <ExportButton />
          ) : (
            <UpgradeToExportButton />
          )
        ) : (
          <ExportButtonDisabled />
        )}
        <UserDropdown />
      </Styled.RightBlock>
    </Styled.Header>
  )
}

export default Header
